import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { Accounts } from 'meteor/accounts-base';
import { Bert } from 'meteor/themeteorchef:bert';

import { isWeb, getRedirectPath } from '../../../modules/checkDeployEnv';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import PageHeader from '../../atoms/PageHeader';
import AccountPageFooter from '../../components/AccountPageFooter';
import OAuthLoginButtons from '../../components/OAuthLoginButtons';
import Validation from '../../containers/Validation';
import methodPromise from '../../../modules/method-promise-wrapper';

class SignUp extends Component {
  state = {
    notARobot: false
  };

  handleSubmit = async form => {
    const newUser = {
      email: form.emailAddress.value,
      password: form.password.value,
      role: 'free-user',
      profile: {
        name: {
          first: form.firstName.value,
          last: form.lastName.value
        }
      }
    };
    const APISettings = await methodPromise('admin.fetchAPISetting');
    if (APISettings.length > 0) {
      newUser.role = [APISettings[0].defaultUserRole];
    }

    Accounts.createUser(newUser, error => {
      if (error) {
        handleErrorInClient(error);
      } else {
        Meteor.call('users.sendVerificationEmail');
        Bert.alert('Welcome!', 'success');
        const { history, deployEnv } = this.props;
        history.push(getRedirectPath(deployEnv));
      }
    });
  };

  render() {
    const { notARobot } = this.state;
    const { deployEnv } = this.props;
    const validationProps = {
      rules: {
        firstName: {
          required: true
        },
        lastName: {
          required: true
        },
        emailAddress: {
          required: true,
          email: true
        },
        password: {
          required: true,
          minlength: 6
        },
        repeatPassword: {
          required: true,
          minlength: 6,
          equalTo: '[name="password"]'
        }
      },
      messages: {
        firstName: {
          required: "What's your first name?"
        },
        lastName: {
          required: "What's your last name?"
        },
        emailAddress: {
          required: 'Need an email address here.',
          email: 'Is this email address correct?'
        },
        password: {
          required: 'Need a password here.',
          minlength: 'Please use at least six characters.'
        },
        repeatPassword: {
          required: 'Repeat your password, please.',
          equalTo: "Hmm, your passwords don't match. Try again?"
        }
      },
      submitHandler: form => {
        this.handleSubmit(form);
      }
    };
    return (
      <>
        <Row className="justify-content-center">
          <Col xs={12} sm={8} md={6}>
            <PageHeader>
              <h4>Sign Up</h4>
            </PageHeader>
            {isWeb(deployEnv) && (
              <Row>
                <Col xs={12}>
                  <OAuthLoginButtons
                    services={['facebook', 'esri', 'google']}
                    emailMessage={{
                      offset: 97,
                      text: 'Sign Up with an Email Address'
                    }}
                  />
                </Col>
              </Row>
            )}
            <Validation {...validationProps}>
              <Form onSubmit={event => event.preventDefault()}>
                <Form.Row>
                  <Form.Group as={Col} xs={6}>
                    <Form.Label>First Name</Form.Label>
                    <Form.Control type="text" name="firstName" />
                  </Form.Group>
                  <Form.Group as={Col} xs={6}>
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control type="text" name="lastName" />
                  </Form.Group>
                </Form.Row>
                <Form.Group>
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control type="text" name="emailAddress" />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" name="password" />
                  <Form.Text className="text-muted">Use at least six characters.</Form.Text>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Repeat Password</Form.Label>
                  <Form.Control type="password" name="repeatPassword" />
                </Form.Group>
                <Form.Group>
                  <Form.Check
                    onChange={e => this.setState({ notARobot: e.target.checked })}
                    label={<strong>Not A Robot</strong>}
                  />
                </Form.Group>
                <Button disabled={!notARobot} type="submit" variant="success" block>
                  Sign Up
                </Button>
                <AccountPageFooter>
                  <p>
                    Already have an account? <Link to="/login">Log In</Link>.
                  </p>
                </AccountPageFooter>
              </Form>
            </Validation>
          </Col>
        </Row>
      </>
    );
  }
}

SignUp.propTypes = {
  history: PropTypes.object.isRequired,
  deployConfig: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired
};

export default SignUp;
